import styled from "styled-components";
import { ISideItem } from "@/components/Sidebar/constant/SideList";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { host } from "project-config/utils/env";

export interface SidebarProps {
  sideList: ISideItem[];
  activePath?: string;
  onChange?: (path?: string) => void;
}

export default function Sidebar({
  sideList,
  activePath,
  onChange,
}: SidebarProps) {
  const t = getTranslateNsT("center");
  return (
    <SidebarWrapper>
      <div>
        {sideList.map((i) => {
          if (i.hidden) return null;

          return (
            <SideItem
              key={i.name}
              onClick={() => onChange?.(i?.path)}
              className={
                activePath === i.path || i.childrenPath?.includes(activePath!)
                  ? "sidebar--active"
                  : ""
              }
            >
              {i.logo}
              <span>{i.name}</span>
              {i.sufIcon}
            </SideItem>
          );
        })}
      </div>
      <BackToRenderButton as="a" href={host}>
        <LeftArrowIcon />
        {t("sidebar_to_render")}
      </BackToRenderButton>
    </SidebarWrapper>
  );
}

const LeftArrowIcon = styled.div`
  width: 9px;
  height: 9px;
  border-left: 2px solid var(--main-color);
  border-bottom: 2px solid var(--main-color);
  transform: rotate(45deg);
  margin-right: 5px;
`;

const BackToRenderButton = styled.div`
  height: 48px;
  border-top: 1px solid #404146;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--main-color) !important;
  cursor: pointer;
  &:hover {
    color: var(--main-color);
  }
`;

const SideItem = styled.div`
  display: flex;
  align-items: center;
  padding-left: 18px;
  height: 40px;
  cursor: pointer;
  border-left: 3px solid transparent;
  color: #fff;
  span {
    margin: 0 2px 0 18px;
  }
  &.sidebar--active {
    border-left: 3px solid var(--main-color);
    background: linear-gradient(
      270deg,
      var(--color-main-alpha-022) 0%,
      var(--color-main-alpha-2) 100%
    );
  }
`;

const SidebarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
